import {
  Grid,
  Box,
  Button,
  Image,
  Badge,
  Input,
  VStack,
  Heading,
  Spacer,
  Center,
  Text,
  Flex,
  HStack,
  Progress,
  SimpleGrid,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useWallet, useAnchorWallet } from "@solana/wallet-adapter-react";
import * as anchor from "@project-serum/anchor";

import axios from "axios";

import { useParams } from "react-router-dom";

import background from "./img/background.png";

import {
  getFightState,
  getMonsterProgram,
  getMonster,
  Ability,
  fetchMonsterAbility,
  MetadataType,
  fetchOtherMonsterAbility,
  joinMonsterFight,
  useMonsterAbility,
} from "./MonsterProgram";

import { Monster, BattleState } from "./MonsterProgram";

import { PublicKey } from "@solana/web3.js";

import slime1 from "./img/66.png";
import slime2 from "./img/97.png";

const BattleStateString = {
  0: "We are waiting for a challenger to approach...",
  1: "It is player 1's turn!",
  2: "It is player 2's turn!",
  3: "Player 1 has won!",
  4: "Player 2 has won!",
};

interface AbilityButtonProps {
  abilitySlot: number;
  monsterKey: anchor.web3.PublicKey;
  attackedMonsterKey: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  playerNumber: number;
}

interface MonsterImageProps {
  connection: anchor.web3.Connection,
  monsterKey: anchor.web3.PublicKey
}

export interface FightProps {
  connection: anchor.web3.Connection;
}

enum UserRole {
  PlayerOne,
  PlayerTwo,
  Entrant,
  Spectator,
}

const Fight = (props: FightProps) => {
  const wallet = useWallet();
  const anchorWallet = useAnchorWallet();
  const { id } = useParams();

  const [battleState, setBattleState] = useState<BattleState>();
  const [userRole, setUserRole] = useState<UserRole>(UserRole.Spectator);

  const [monster1, setMonster1] = useState<Monster>();
  const [monster2, setMonster2] = useState<Monster>();
  const [monster1Image, setImage1] = useState<string>();
  const [monster2Image, setImage2] = useState<string>();

  const AbilityButton = (props: AbilityButtonProps) => {
    const [ability, setAbility] = useState<Ability>();

    var disabled = true;

    if (
      props.playerNumber === 1 &&
      battleState.battleState === 1 &&
      wallet.publicKey.equals(battleState.player1)
    ) {
      disabled = false;
    } else if (
      props.playerNumber === 2 &&
      battleState.battleState === 2 &&
      wallet.publicKey.equals(battleState.player2)
    ) {
      disabled = false;
    }

    useEffect(() => {
      const loadAbility = async () => {
        try {
          let _ability: Ability = await fetchOtherMonsterAbility(
            anchorWallet as anchor.Wallet,
            props.monsterKey,
            props.connection,
            props.abilitySlot
          );
          setAbility(_ability);
        } catch (err) {
          console.log(err);
        }
      };

      loadAbility();
    }, [props.abilitySlot, props.monsterKey, props.connection]);

    if (!ability) {
      return (
        <Button disabled={true} fontSize="0.8em">
          None
        </Button>
      );
    }
    return (
      <Box>
        {ability && (
          <Button
            w="100%"
            fontSize="0.8em"
            onClick={() =>
              AttackHandler(
                props.monsterKey,
                props.attackedMonsterKey,
                props.abilitySlot,
                id,
                props.playerNumber
              )
            }
            disabled={disabled}
          >
            {ability.name}
          </Button>
        )}
      </Box>
    );
  };

  const AttackHandler = async (
    monster: anchor.web3.PublicKey,
    attackedMonster: anchor.web3.PublicKey,
    moveSlot: number,
    battle: anchor.web3.PublicKey,
    playerNum: number
  ) => {
    await useMonsterAbility(
      anchorWallet as anchor.Wallet,
      props.connection,
      monster,
      moveSlot,
      attackedMonster,
      battle,
      playerNum
    );
  };



  useEffect(() => {
    console.log("ok we changed role lets go");
  }, [userRole]);

  useEffect(() => {
    async function connectBattleState() {
      let _battleState = await getFightState(
        anchorWallet as anchor.Wallet,
        props.connection,
        new PublicKey(id)
      );

      const program = await getMonsterProgram(
        anchorWallet as anchor.Wallet,
        props.connection
      );

      const eventId = program.addEventListener("BattleState", (event, slot) => {
        console.log("got state");
        console.log(event);
        setBattleState(event);
      });

      setBattleState(_battleState);

      if (wallet.publicKey.equals(_battleState.player1)) {
        console.log("You are player 1");
        setUserRole(UserRole.PlayerOne);
      } else if (wallet.publicKey.equals(_battleState.player2)) {
        console.log("You are player 2");
        setUserRole(UserRole.PlayerTwo);
      } else if (
        _battleState.player2.toString() === "11111111111111111111111111111111"
      ) {
        console.log("You can join this fight");
        setUserRole(UserRole.Entrant);
      } else {
        setUserRole(UserRole.Spectator);
        console.log("You are a spectator");
      }
    }

    connectBattleState();
  }, [wallet, props.connection, id, anchorWallet]);

  async function joinFight() {
    await joinMonsterFight(anchorWallet as anchor.Wallet, props.connection, id);
    setUserRole(UserRole.PlayerTwo);
  }


    var test;

    if (battleState) {
      if (userRole === UserRole.PlayerOne) {
        test = {
          monsterKey: battleState.monster1,
          attackedMonsterKey: battleState.monster2,
          playerNumber: 1
        }
      } else if (userRole === UserRole.PlayerTwo) {
        test = {
          monsterKey: battleState.monster2,
          attackedMonsterKey: battleState.monster1,
          playerNumber: 2
        }
      }
      
    }
  

    const OpponentMonster = (props: MonsterImageProps) => {

      const [monsterImage, setMonsterImage] = useState<string>();
      const [monster, setMonster] = useState<Monster>();
  
      useEffect(() => {
        const loadImage = async () => {
          try {
            let monsterState: any = await getMonster(
              anchorWallet as anchor.Wallet,
              props.connection,
              props.monsterKey
            );
  
            axios.get<MetadataType>(monsterState.uri).then((res) => {
              console.log(res);
              setMonster(monsterState);
              setMonsterImage(res.data.image);
            });
          } catch (err) {
            console.log(err);
          }
        }
  
        loadImage();
      }, [props.connection, props.monsterKey])
  
      if (!monster) {
        return(<Box>Loading..</Box>)
      }
      return(
        <Flex flexFlow="column" w="200px" alignItems="center" mt="32px">
          <Image w="full" src={monsterImage}/>
          <Text fontSize="0.8em">{monster.name}</Text>
        </Flex>
      )
    }

  const MonsterImage = (props: MonsterImageProps) => {

    const [monsterImage, setMonsterImage] = useState<string>();
    const [monster, setMonster] = useState<Monster>();

    useEffect(() => {
      const loadImage = async () => {
        try {
          let monsterState: any = await getMonster(
            anchorWallet as anchor.Wallet,
            props.connection,
            props.monsterKey
          );

          axios.get<MetadataType>(monsterState.uri).then((res) => {
            console.log(res);
            setMonster(monsterState);
            setMonsterImage(res.data.image);
          });
        } catch (err) {
          console.log(err);
        }
      }

      loadImage();
    }, [props.connection, props.monsterKey])

    if (!monster) {
      return(<Box>Loading..</Box>)
    }
    return(
      <Flex flexFlow="column" w="200px" p="4px" border="solid" alignItems="center">
        <Image w="full" src={monsterImage}/>
        <Text fontSize="0.8em">{monster.name}</Text>
      </Flex>
    )
  }
  

  if (!battleState) {
    return <Box>Loading Battle...</Box>;
  }
  return (
    <Flex h="100vh">
      <Flex
        position="sticky"
        w="full"
        bg="red"
        flexFlow="column"
        alignItems="center"
        backgroundImage={background}
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
      >
        <Flex
          bg="black"
          position="absolute"
          top="10px"
          left="10px"
          flexFlow="column"
          p="2"
          border="solid"
          alignItems="center"
        >
          <Text>Opponent</Text>
          <Box>HP: {userRole === UserRole.PlayerOne ? battleState.monster2Health : battleState.monster1Health}</Box>
        </Flex>
        <OpponentMonster connection={props.connection} monsterKey={userRole === UserRole.PlayerOne ? battleState.monster2 : battleState.monster1}/>
        {/* <Image position="absolute" top="20%" src={slime2} maxW="200px" /> */}
      </Flex>
      

      
      
      <Flex position="fixed" bottom="20px" left="10px" right="10px" p="2">
        {/* <Image h="150px" src={slime1} p="4px" border="solid" /> */}
        <MonsterImage connection={props.connection} monsterKey={userRole === UserRole.PlayerOne ? battleState.monster1 : battleState.monster2}/>
        <Flex p="4" bg="black" mx="4px" border="solid" w="full">
          {BattleStateString[battleState.battleState]}
                {userRole === UserRole.Entrant && (
        <Box marginLeft="auto" marginRight="4px">
          <Button onClick={joinFight}>Join Fight</Button>
        </Box>
      )}
        </Flex>
        <Spacer />
        <Flex flexFlow="column" alignItems="center" bg="black" border="solid">
          <Text mt={2}>Abilities</Text>
          <SimpleGrid columns={2} p="4" spacing={2}>
            <AbilityButton
            {...test}
              abilitySlot={1}
              connection={props.connection}

            />
            <AbilityButton
            {...test}
              abilitySlot={2}
              connection={props.connection}

            />
            <AbilityButton
            {...test}
              abilitySlot={3}
              connection={props.connection}

            />
            <AbilityButton
            {...test}
              abilitySlot={4}
              connection={props.connection}

            />
          </SimpleGrid>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Fight;
